// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueAwesomeSwiper from "vue-awesome-swiper"
import VueAnimateOnScroll from './util/animateScroll'
import VueAnimateNumber from 'vue-animate-number'
import 'element-ui/lib/theme-chalk/index.css'
import 'animate.css'
import "swiper/dist/css/swiper.css"
// import VueI18n from 'vue-i18n'
import store from './store'
import  'lib-flexible'
import 'babel-polyfill'
import '../static/Ueditor/ueditor.config.js'
import '../static/Ueditor/ueditor.all.js'
import '../static/Ueditor/lang/zh-cn/zh-cn.js'
import i18n from './common/lang/index.js'

Vue.use(ElementUI);
// Vue.use(VueI18n);
Vue.use(VueAwesomeSwiper);
Vue.use(VueAnimateOnScroll)
Vue.use(VueAnimateNumber)


// Vue.prototype.$axios = axios;
// axios.defaults.withCredentials = true;  //必须使用cookie

Vue.config.productionTip = false;

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

// 注册全局动画组件
//注册'v-animate'  当元素出现在可视范围时添加类名触发动效样式
Vue.directive('animate', {
  inserted: function (el, binding) {
    // 聚焦元素
    binding.addClass = () => {
      const { top } = el.getBoundingClientRect()
      const h = document.documentElement.clientHeight || document.body.clientHeight
      if (top < h) {
        if(el.className.indexOf(binding.value) == -1 ){
          // 初次还未绑定过，则新增类名(注意：下面单引号中间是一个空格！！！)
          el.className = binding.value+' '+el.className
        }
        if (binding.addClass) {
          window.removeEventListener('scroll', binding.addClass)
        }
      }
    }
    window.addEventListener('scroll', binding.addClass,true)
    binding.addClass()
  },
  unbind: function (el, binding) {
    if (binding.addClass) {
      window.removeEventListener('scroll', binding.addClass)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, //使用store
  i18n,//国际化
  components: { App },
  template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js